// extracted by mini-css-extract-plugin
export default {"card":"BuyAndSellStocksMobile_card__HL-uL","inCardContainer":"BuyAndSellStocksMobile_inCardContainer__OHxrl"};